import { coordinatorRootApi } from "@/lib/api";

export const acceptInvitation = async ({
  invitationId,
}: {
  invitationId: string;
}): Promise<void> => {
  await coordinatorRootApi.post(`/invitations/${invitationId}/accept`);
};
